import $ from "jquery";
import api from "./ajax";
import * as bootstrap from "bootstrap";

const RemoveTipping = () => {
	const confirmRemoveTippingModal = document.getElementById('confirmRemoveTippingModal');
	const removeTippingBtn = document.getElementById('removeTipping');

	if (!confirmRemoveTippingModal || !removeTippingBtn) {
		return;
	}

	const removeTruck = async (button) => {
		const ref = button.getAttribute('data-ref');

		if (!ref) {
			return;
		}

		const row = document.getElementById(ref);

		const truckId = row.getAttribute('data-id');


		if (truckId) {
			// Remove the truck from the database
			// Show the loading icon on the button
			$(button).children('.fa-spinner').show();

			// Remove the truck from the database
			const data = await api.deleteTipping(truckId);

			$(button).children('.fa-spinner').hide();

		}

		row.parentNode.removeChild(row);

		// Close the modal
		const modal = bootstrap.Modal.getInstance(confirmRemoveTippingModal);

		modal.hide();
	}

	confirmRemoveTippingModal.addEventListener('show.bs.modal', event => {
		const button = event.relatedTarget;
		const ref = button.getAttribute('data-ref');
		const rego = button.getAttribute('data-rego');
		const regoPlaceholder = confirmRemoveTippingModal.querySelector('#regoPlaceholder');
		const deleteBtn = confirmRemoveTippingModal.querySelector('#removeTipping');

		deleteBtn.setAttribute('data-ref', ref);

		regoPlaceholder.textContent = rego;
	});

	removeTippingBtn.addEventListener('click', (e) => removeTruck(e.target));
};

export default RemoveTipping;